import { getPresupuesto } from './getPresupuesto'
import { validarValorTomaUsado } from './validarValorTomaUsado'
import { getCostosDePatentamiento } from './getCostosDePatentamiento'
import {
    getPresupuestoUltimoEditado,
    setPresupuestoUltimoEditado,
    getPresupuestoAutomaticSave,
    setPresupuestoAutomaticSave
} from './ultimoPresupuestoEditado'
import { getCreditsByMMV } from './getCreditsByMMV'
import { generateExcel } from './generateExcel'
import { getBranchOffices } from './getBranchOffices'
import { getAlertsUltimoPresupuestoEditado } from './getAlertsUltimoPresupuestoEditado'
import { getCftQuoteAvg } from './getCftQuoteAvg'
import { retryOfferDMS } from './retryOfferDMS'
import { sendEmailInteractive } from './sendEmailInteractive'
import { sendEmailPdf } from './sendEmailPdf'
import { getLinkInteractive } from './getLinkInteractive'
import { getPublicBudget } from './getPublicBudget'
import { getPublicBudgetToken } from './getPublicBudgetToken'
import { createInteractiveBudget } from 'BFF/BFF_presupuestador/createInteractiveBudget'

export const Presupuestador = {
    getPresupuesto,
    validarValorTomaUsado,
    getCostosDePatentamiento,
    getPresupuestoUltimoEditado,
    setPresupuestoUltimoEditado,
    getPresupuestoAutomaticSave,
    setPresupuestoAutomaticSave,
    getCreditsByMMV,
    generateExcel,
    getBranchOffices,
    getAlertsUltimoPresupuestoEditado,
    getCftQuoteAvg,
    retryOfferDMS,
    sendEmailPdf,
    sendEmailInteractive,
    getLinkInteractive,
    getPublicBudget,
    getPublicBudgetToken,
    createInteractiveBudget
}
